module.exports = __webpack_public_path__ + "img/photo-food-moments.a50156d7.png";